import includes from 'lodash/includes';
import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {USER_DATA} from 'user/user-prop-types';
import classNames from 'classnames';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {compose} from 'redux';
import IconArrowLeft from '@spothero/icons/arrow-left';
import Button from '@spothero/ui/button';
import withConfig from 'config/withConfig';
import {toggleMobileListView} from 'search/search-actions';
import {resetSelectedSpot, updateSelected} from 'spot/spot-actions';
import {goBack, replace} from 'router/router-actions';
import {userLogout} from 'user/user-actions';
import Navigation from './Navigation';

class HeaderMobile extends PureComponent {
    static propTypes = {
        history: PropTypes.shape({
            action: PropTypes.string,
            location: PropTypes.shape({
                pathname: PropTypes.string,
            }),
        }),
        className: PropTypes.string,
        isProduction: PropTypes.bool,
        user: PropTypes.shape(USER_DATA).isRequired,
        isSearchPage: PropTypes.bool,
        pageType: PropTypes.string,
        searchUrl: PropTypes.string,
        latitude: PropTypes.number,
        longitude: PropTypes.number,
        isMobileListViewActive: PropTypes.bool.isRequired,
        selectedSpot: PropTypes.object,
        expandedData: PropTypes.array.isRequired,
        collapsedData: PropTypes.array.isRequired,
        showMobileListView: PropTypes.func,
        setSelectedSpot: PropTypes.func,
        clearSelectedSpot: PropTypes.func.isRequired,
        routeBack: PropTypes.func.isRequired,
        routeReplace: PropTypes.func.isRequired,
        onUserLogout: PropTypes.func.isRequired,
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {
            history: {
                location: {pathname},
            },
            isSearchPage,
            selectedSpot,
            setSelectedSpot,
        } = this.props;

        if (
            isSearchPage &&
            !includes(pathname, '/spot-details/') &&
            selectedSpot
        ) {
            // make sure that when on search and not a spot details page, selectedSpot is not defined
            setSelectedSpot();
        }
    }

    _onListViewClick = () => {
        this.props.showMobileListView(true);
    };

    _onMapViewClick = () => {
        this.props.showMobileListView(false);
    };

    _onBackClick = () => {
        const {
            history: {action},
            pageType,
            searchUrl,
            latitude,
            longitude,
            routeReplace,
            setSelectedSpot,
            routeBack,
        } = this.props;

        if (action === 'POP') {
            // initial load was straight to spot details, go back to the correct search url based on where this spot is
            // and not whatever the prior page was when the user got to our site (possibly an external URL)
            const url =
                pageType === 'address' || searchUrl === null
                    ? `/search?latitude=${latitude}&longitude=${longitude}`
                    : searchUrl;

            setSelectedSpot();
            routeReplace(url);
        } else {
            // arrived on spot details through search, go back to search page
            routeBack();
        }
    };

    render() {
        const {
            history: {
                location: {pathname},
            },
            className,
            isProduction,
            user,
            expandedData,
            collapsedData,
            isMobileListViewActive,
            isSearchPage,
            clearSelectedSpot,
            onUserLogout,
        } = this.props;
        const isSpotDetailsPage = includes(pathname, '/spot-details/');
        const alternateControl = isSpotDetailsPage
            ? 'back'
            : isMobileListViewActive
            ? 'map'
            : 'list';
        const classes = classNames(
            'Header',
            {
                'Header-brand-hidden':
                    isSearchPage && alternateControl === 'back',
            },
            className
        );

        return (
            <header className={classes} role="banner">
                <div className="Header-bar">
                    {isSearchPage && !isSpotDetailsPage && (
                        <>
                            {alternateControl === 'list' && (
                                <Button
                                    className="Header-alternate-control Header-map-toggle"
                                    onClick={this._onListViewClick}
                                >
                                    List
                                </Button>
                            )}
                            {alternateControl === 'map' && (
                                <Button
                                    className="Header-alternate-control Header-map-toggle"
                                    onClick={this._onMapViewClick}
                                >
                                    Map
                                </Button>
                            )}
                        </>
                    )}
                    {isSearchPage && (
                        <>
                            {alternateControl === 'back' && (
                                <Button
                                    className="Header-alternate-control HeaderMobile-back"
                                    onClick={this._onBackClick}
                                >
                                    <IconArrowLeft />
                                </Button>
                            )}
                        </>
                    )}
                </div>
                <div className="Header-bar-background" />
                <Navigation
                    isProduction={isProduction}
                    user={user}
                    collapsedData={collapsedData}
                    expandedData={expandedData}
                    onItemSelected={clearSelectedSpot}
                    onUserLogout={onUserLogout}
                />
            </header>
        );
    }
}

const mapStateToProps = state => {
    const {
        search: {
            data: {isMobileListViewActive},
        },
        searchRequest: {
            isSearchPage,
            pageType,
            search_url: searchUrl,
            latitude,
            longitude,
        },
        spot: {selected},
        user: {data: user},
    } = state;

    return {
        user,
        isMobileListViewActive,
        selectedSpot: selected,
        isSearchPage,
        latitude,
        longitude,
        pageType,
        searchUrl,
    };
};

const mapDispatchToProps = {
    showMobileListView: toggleMobileListView,
    setSelectedSpot: updateSelected,
    clearSelectedSpot: resetSelectedSpot,
    onUserLogout: userLogout,
    routeBack: goBack,
    routeReplace: replace,
};

const enhance = compose(
    withConfig(['isProduction']),
    withRouter,
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
);

export default enhance(HeaderMobile);
